import {useCatalog} from "../../store/catalog";
import {SORT_OPTIONS} from "./constants";
import {Pagination} from "./Pagination";

export function CatalogControls() {
    const {size, setSize, sort, setSort} = useCatalog();

    return (
        <div className="flex flex-col gap-4">
            <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 sm:gap-6">
                <div className="flex items-center gap-3 shrink-0">
                    <span
                        className="text-[10px] font-black pt-dark-blue uppercase tracking-widest whitespace-nowrap">Show</span>
                    <select
                        className="select !h-auto font-bold pt-dark-blue !py-3 !pl-3 !pr-7"
                        value={size}
                        onChange={e => setSize(Number(e.target.value))}
                    >
                        <option value={12}>12</option>
                        <option value={24}>24</option>
                        <option value={48}>48</option>
                    </select>
                </div>

                <div className="flex items-center gap-3 shrink-0">
                    <span
                        className="text-[10px] font-black pt-dark-blue uppercase tracking-widest whitespace-nowrap">Sort</span>
                    <select
                        className="select !h-auto font-bold pt-dark-blue !py-3 !pl-3 !pr-7"
                        value={sort || ''}
                        onChange={e => setSort(e.target.value)}
                    >
                        {SORT_OPTIONS.map(o => (
                            <option key={o.value || 'default'} value={o.value}>{o.label}</option>
                        ))}
                    </select>
                </div>
                <div className="flex-1 min-w-0">
                    <Pagination variant="bar"/>
                </div>
            </div>
        </div>
    );
}